import Vue from 'vue'
import App from './App'
import router from './router'
import fetch from './utils/fetch'
import './utils/promise-enhance'
import './utils/element-ui'

import * as transformFilters from './utils/filter'

Vue.filter('toTime', transformFilters.toTime)
Vue.filter('toDate', transformFilters.toDate)
Vue.filter('toDateTime', transformFilters.toDateTime)
Vue.filter('toText', transformFilters.toText)
Vue.filter('htmlToText', transformFilters.htmlToText)

Vue.config.productionTip = false

Vue.prototype.$http = fetch

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js